import { BackgroundTaskBase } from "@/utils/background-tasks";
import { FaroText, grey, NO_TRANSLATE_CLASS } from "@faro-lotv/flat-ui";
import {
  SceneWorkerErrorCode,
  StructuredExportWorkerErrorCode,
  validatePointcloudPartialResult,
} from "@faro-lotv/service-wires";
import { Stack } from "@mui/system";
import type { JSX } from "react";
import { CopyButton } from "../../../copy-button";

/**
 * @returns error details for a task, undefined if not available
 * @param task The task to get error details for
 */
export function taskErrorDetails(
  task: BackgroundTaskBase,
): JSX.Element | undefined {
  if (
    (task.errorCode === SceneWorkerErrorCode.partialScanProcessingFailure ||
      task.errorCode === StructuredExportWorkerErrorCode.partialSuccess) &&
    validatePointcloudPartialResult(task.metadata?.result) &&
    task.metadata.result.failedScans
  ) {
    return (
      <>
        <FaroText variant="labelS" sx={{ textTransform: "uppercase" }}>
          Failed scans
        </FaroText>
        <CopyableList
          items={task.metadata.result.failedScans.map((scan) => scan.scanName)}
        />
      </>
    );
  }
}

type CopyableListProps = {
  /** The items to show in the list */
  items: string[];
};

/** @returns a list of items with a button to copy them to the clipboard */
function CopyableList({ items }: CopyableListProps): JSX.Element {
  return (
    <Stack className={NO_TRANSLATE_CLASS}>
      {items.map((item, index) => (
        <Stack
          key={index}
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            color: grey[600],

            ".MuiIconButton-root": {
              opacity: 0,
              transition: "opacity 0.1s",
            },

            ":hover": {
              ".MuiIconButton-root": {
                opacity: 1,
              },
            },
          }}
        >
          <FaroText variant="bodyS" color="inherit">
            {item}
          </FaroText>
          <CopyButton text={item} />
        </Stack>
      ))}
    </Stack>
  );
}
